export default __webpack_public_path__ + "static/media/427.84385038.png";